module.exports = __webpack_public_path__ + "img/star.0474a059.svg";